import { render } from "./Collaborators.vue?vue&type=template&id=a98130e4&scoped=true"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"

import "./Collaborators.vue?vue&type=style&index=0&id=a98130e4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a98130e4"

export default script